import { Component, model, output } from '@angular/core';
import { FilterType, TabButtonGroup } from '../../models';

@Component({
  selector: 'app-tab-group',
  standalone: true,
  imports: [],
  templateUrl: './tab-group.component.html',
  styleUrl: './tab-group.component.scss'
})

export class TabGroupComponent {
  tabButtonGroup = model<TabButtonGroup[]>([]);
  selectedTab = output<FilterType>();

  onTabClick(button: TabButtonGroup) {
    this.tabButtonGroup.update((buttons: TabButtonGroup[]) => {
      return buttons.map((btn) => {
        if (button.value && btn.value === button.value) {
            return { ...btn, selected: true };
        } else if (button.label && btn.label === button.label) {
          return { ...btn, selected: true };
        }
        return { ...btn, selected: false };
      });
    });
    
    this.selectedTab.emit(button.value);
  }
}
